
import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { RL1SlipSettingsSetup } from "../../../components/RL1Slip";

export interface IRL1SlipSettingsSetupPage {}

export const RL1SlipSettingsSetupPage: FC<IRL1SlipSettingsSetupPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="RL-1 Slip Settings"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Compliance", navigateTo: "/compliance/rl1/list" },
        // { text: "RL-1", navigateTo: "/compliance/rl1/list" },
        // { text: "RL-1 Slips Settings", navigateTo: "/compliance/rl1/setting" },
      ]}
      mainContents={<RL1SlipSettingsSetup testId="rl1-slip-settings-setup" />}
    />
  );
};
